import { IGuests } from '../../../types/filters';

export const defaultState: IGuests = {
  adults: 1,
  children: 0,
};
